import { action } from 'satcheljs';

export const showTokenExpirationNotification = action('showTokenExpirationNotification');
